import { render, staticRenderFns } from "./ContactAppointments.vue?vue&type=template&id=2f14c994&scoped=true&"
import script from "./ContactAppointments.vue?vue&type=script&lang=js&"
export * from "./ContactAppointments.vue?vue&type=script&lang=js&"
import style0 from "./ContactAppointments.vue?vue&type=style&index=0&id=2f14c994&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f14c994",
  null
  
)

export default component.exports